
import React, { useMemo } from 'react'
import moment from 'moment/moment'
import {
    Document as PDFDocument,
    Page as PDFPage,
    Text as PDFText,
    View, StyleSheet
} from '@react-pdf/renderer'
import { DocumentServiceProvider } from '@evertel/service'
import { Document, WidgetsProvider } from '@evertel/schema-parser'
import { ContainerProvider, Container } from '@evertel/di'
import { ReadWidgets as ReadPdfWidgets } from './schema-pdf-widgets/ReadWidgets'
import { APIDataDocument, APIDataDocumentSchema } from '@evertel/types'
import DocumentHeader from './schema-pdf-widgets/DocumentHeader'

interface DocumentPDFProps {
    user: number
    document: APIDataDocument
    value: any
    schema: APIDataDocumentSchema
    container: Container
}

const DocumentPDF: React.FC<DocumentPDFProps> = ({
    user,
    document,
    schema,
    value,
    container
}) => {

    const styles = useMemo(() => getStyles(), [])

    if (!document || !schema) return <PDFDocument/>

    return (
        <PDFDocument
            title={`${document.name || 'EverDoc'}-${schema.name}.pdf`}
            creator="Evertel">
            <PDFPage
                wrap
                size="LETTER"
                style={{
                    padding: 20,
                    paddingBottom: 70,
                    fontSize: 11
                }}>
                <ContainerProvider value={container}>
                    <DocumentServiceProvider services={[{
                        id: 'meta', value: { media: document.media }
                    }]}>
                        <View style={styles.section}>
                            <DocumentHeader departmentId={document.departmentId} documentName={document.name}/>
                            <WidgetsProvider value={ReadPdfWidgets}>
                                <Document
                                    layout="full"
                                    schema={schema.schema}
                                    schemaId={schema.id}
                                    documentId={document.id}
                                    value={value}
                                />
                            </WidgetsProvider>
                        </View>
                    </DocumentServiceProvider>
                    <View fixed style={styles.footer}>
                        <PDFText style={styles.docInfo}>
                            Last Updated: {moment(document?.updatedDate).format('ll @ HH:mm')}
                        </PDFText>
                        <PDFText style={[styles.docInfo, styles.docRight]}>
                            {`ID: d${document?.id}.s${document?.documentSchemaId}.r${document?.documentSchemaRevisionId ?? 0}`}
                        </PDFText>
                        <PDFText style={styles.docName}>
                            {`${document.name || 'EverDoc'}-${schema.name}.pdf`} | {moment().format('LL')}
                        </PDFText>
                        <PDFText
                            style={styles.pageNumbers}
                            render={({ pageNumber, totalPages }) => (
                                (totalPages > 0) && `${pageNumber} / ${totalPages}`
                            )}
                        />
                    </View>
                </ContainerProvider>
            </PDFPage>
        </PDFDocument>
    )
}

const getStyles = () => (StyleSheet.create({
    section: {

    },
    metaStyle: {
        fontSize: 10,
        color: 'gray'
    },
    footer: {
        position: 'absolute',
        fontSize: 8,
        bottom: 0,
        right: 0,
        left: 0,
        height: 35,
        textAlign: 'center',
        color: '#666666'
    },
    docInfo: {
        fontSize: 6,
        position: 'absolute',
        left: 20,
        top: 6
    },
    docRight: {
        left: 'auto',
        right: 20
    },
    docName: {
        position: 'absolute',
        left: 20,
        top: 15
    },
    pageNumbers: {
        position: 'absolute',
        right: 20,
        top: 15
    }
}))

export {
    DocumentPDF
}
